"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Minus = function Minus(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: props.backgroundColor
  }), _react.default.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "7.5",
    opacity: "0.5",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M13.0208 11.9792H14.5833C14.7215 11.9792 14.8539 12.0341 14.9516 12.1318C15.0493 12.2295 15.1042 12.3619 15.1042 12.5001C15.1042 12.6382 15.0493 12.7707 14.9516 12.8684C14.8539 12.966 14.7215 13.0209 14.5833 13.0209H13.0208H11.9792H10.4167C10.2785 13.0209 10.1461 12.966 10.0484 12.8684C9.95071 12.7707 9.89584 12.6382 9.89584 12.5001C9.89584 12.3619 9.95071 12.2295 10.0484 12.1318C10.1461 12.0341 10.2785 11.9792 10.4167 11.9792H11.9792H13.0208Z",
    fill: "white"
  }));
};

Minus.defaultProps = {
  altText: "Minus",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Minus.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Minus;
exports.default = _default;